/**
 * Evidence Hub Custom JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
    // Check if filters close button exists on the page
    const filtersCloseBtn = document.querySelector('.filters-close-btn');
    
    if (filtersCloseBtn) {
        // Add click event listener to the filters close button
        filtersCloseBtn.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Find the filters collapse element
            const filtersCollapse = document.querySelector('.filters-collapse');
            
            if (filtersCollapse) {
                // Remove the 'show' class from the filters collapse element
                filtersCollapse.classList.remove('show');
            }
        });
    }

    // Monitor filters collapse state and add/remove body class
    const filtersCollapse = document.querySelector('.filters-collapse');
    
    if (filtersCollapse) {
        // Create a MutationObserver to watch for class changes
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    
                    // Check if the filters collapse has the 'show' class
                    if (target.classList.contains('show')) {
                        document.body.classList.add('eh-filter-open');
                    } else {
                        document.body.classList.remove('eh-filter-open');
                    }
                }
            });
        });

        // Observe the filters collapse element for class changes
        observer.observe(filtersCollapse, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    // Debug: Check for keyboard trapping issues
    const searchForm = document.querySelector('.eh-search-form');
    if (searchForm) {
        // Ensure form doesn't trap focus
        searchForm.addEventListener('keydown', function(e) {
            // Allow normal tab navigation
            if (e.key === 'Tab') {
                // Don't prevent default tab behavior
                return;
            }
        });
    }

    // Add user-is-tabbing class for focus styles
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
            // console.log('Tab pressed, current focus:', document.activeElement);
            document.body.classList.add('user-is-tabbing');
        }
    });

    // Remove user-is-tabbing class on mouse interaction
    document.addEventListener('mousedown', function() {
        document.body.classList.remove('user-is-tabbing');
    });

    // Ensure all form elements have proper tabindex
    const searchButton = document.querySelector('#site-search-desk-submit');
    const clearButton = document.querySelector('.site-search__clear');

    if (searchInput) {
        searchInput.removeAttribute('tabindex');
    }
    if (searchButton) {
        searchButton.removeAttribute('tabindex');
    }
    if (clearButton) {
        clearButton.removeAttribute('tabindex');
    }

    // Mobile apply filters button functionality (767px and below)
    const applyFiltersBtn = document.querySelector('.filters-apply__btn');
    
    if (applyFiltersBtn) {
        applyFiltersBtn.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Check if we're on mobile breakpoint (767px and below)
            if (window.innerWidth <= 767) {
                // Find the filters collapse element
                const filtersCollapse = document.querySelector('#collapseFilters');
                
                if (filtersCollapse) {
                    // Remove the 'show' class from the filters collapse element
                    filtersCollapse.classList.remove('show');
                }
            }
        });
    }

    // Ensure hierarchical menu child buttons are tabbable when visible
    function ensureTabbableButtons() {
        // Find all visible child menus
        const childMenus = document.querySelectorAll('#subtopics .ais-HierarchicalMenu-list--child');
        
        childMenus.forEach(function(menu) {
            // Check if menu is visible
            const style = window.getComputedStyle(menu);
            const isVisible = style.display !== 'none' && menu.offsetParent !== null;
            
            if (isVisible) {
                // Find all child buttons (excluding parent buttons with chevrons)
                const allButtons = menu.querySelectorAll('button.filter-btn');
                const childButtons = Array.from(allButtons).filter(function(button) {
                    return !button.querySelector('.icon-chevron-down');
                });
                
                // Ensure all child buttons have tabindex="0" to be in tab order
                childButtons.forEach(function(button) {
                    button.setAttribute('tabindex', '0');
                });
            }
        });
    }

    // Function to find and focus the newly updated button after Algolia replaces it
    function focusNewlyUpdatedButton(originalButton) {
        if (!originalButton) return;
        
        // Get the aria-label from the original button to find the new one
        const ariaLabel = originalButton.getAttribute('aria-label');
        const buttonText = originalButton.textContent.trim().replace(/\s+/g, ' ');
        
        // Try multiple times as Algolia updates the DOM
        function findAndFocus() {
            // Look for the button with matching aria-label and active class
            const parentItems = document.querySelectorAll('#subtopics .ais-HierarchicalMenu-item--parent');
            
            parentItems.forEach(function(parentItem) {
                const button = parentItem.querySelector('button.filter-btn.active');
                
                // Check if this is the button we're looking for
                if (button && button.querySelector('.icon-chevron-down')) {
                    const buttonAriaLabel = button.getAttribute('aria-label');
                    const buttonTextMatch = button.textContent.trim().replace(/\s+/g, ' ');
                    
                    if (buttonAriaLabel === ariaLabel || buttonTextMatch === buttonText) {
                        // Found the new button - focus it
                        button.focus();
                        return true;
                    }
                }
            });
            
            return false;
        }
        
        // Try immediately
        if (!findAndFocus()) {
            // If not found, try after short delays to catch Algolia's DOM updates
            setTimeout(function() {
                if (!findAndFocus()) {
                    setTimeout(function() {
                        findAndFocus();
                    }, 100);
                }
            }, 10);
        }
    }

    // Keep focus on parent button when clicked/activated, and ensure child buttons are tabbable
    document.addEventListener('click', function(e) {
        const target = e.target.closest('button.filter-btn');
        if (target && target.querySelector('.icon-chevron-down')) {
            // Store reference to the button before Algolia replaces it
            const originalButton = target;
            
            // Parent button was clicked - find and focus the new button after Algolia updates
            setTimeout(function() {
                focusNewlyUpdatedButton(originalButton);
                // Ensure child buttons will be tabbable once menu is rendered
                setTimeout(ensureTabbableButtons, 50);
                setTimeout(ensureTabbableButtons, 100);
                setTimeout(ensureTabbableButtons, 200);
            }, 0);
        }
    }, true); // Use capture phase

    // Handle keyboard activation (Space/Enter) on parent buttons
    document.addEventListener('keydown', function(e) {
        if (e.key === ' ' || e.key === 'Enter') {
            const target = e.target.closest('button.filter-btn');
            if (target && target.querySelector('.icon-chevron-down')) {
                // Store reference to the button before Algolia replaces it
                const originalButton = target;
                
                // Parent button activated - find and focus the new button after Algolia updates
                setTimeout(function() {
                    focusNewlyUpdatedButton(originalButton);
                    // Ensure child buttons will be tabbable once menu is rendered
                    setTimeout(ensureTabbableButtons, 50);
                    setTimeout(ensureTabbableButtons, 100);
                    setTimeout(ensureTabbableButtons, 200);
                }, 0);
            }
        }
    }, true); // Use capture phase

    // Watch for changes in the subtopics container to catch when Algolia injects child menus
    const subtopicsContainer = document.querySelector('#subtopics');
    if (subtopicsContainer) {
        const menuObserver = new MutationObserver(function(mutations) {
            let shouldCheck = false;
            let newlyActiveButton = null;
            
            mutations.forEach(function(mutation) {
                // Check if a child menu was added
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) { // Element node
                            if (node.classList && node.classList.contains('ais-HierarchicalMenu-list--child')) {
                                shouldCheck = true;
                                // Find the parent button that now has active class
                                const parentItem = node.closest('.ais-HierarchicalMenu-item--parent');
                                if (parentItem) {
                                    newlyActiveButton = parentItem.querySelector('button.filter-btn.active');
                                }
                            } else if (node.querySelector && node.querySelector('.ais-HierarchicalMenu-list--child')) {
                                shouldCheck = true;
                            }
                        }
                    });
                }
                
                // Check if class changes indicate menu expansion
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (target.classList.contains('ais-HierarchicalMenu-item--parent')) {
                        shouldCheck = true;
                        // This is a parent item that just got expanded - find its active button
                        newlyActiveButton = target.querySelector('button.filter-btn.active');
                    } else if (target.classList.contains('active') && target.matches('button.filter-btn')) {
                        // A button just got the active class
                        if (target.querySelector('.icon-chevron-down')) {
                            newlyActiveButton = target;
                            shouldCheck = true;
                        }
                    }
                }
            });
            
            if (shouldCheck) {
                // Run immediately and after a frame to catch DOM updates
                ensureTabbableButtons();
                
                // If we found a newly active button, focus it
                if (newlyActiveButton) {
                    requestAnimationFrame(function() {
                        newlyActiveButton.focus();
                        ensureTabbableButtons();
                    });
                } else {
                    requestAnimationFrame(function() {
                        ensureTabbableButtons();
                    });
                }
            }
        });

        // Observe the subtopics container for changes
        menuObserver.observe(subtopicsContainer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    // Initial check
    ensureTabbableButtons();
    
    // Periodic check to catch any missed updates
    setInterval(ensureTabbableButtons, 500);
});
